module.exports = __webpack_public_path__ + "img/memory.16dd2e8b.jpg";